export function getView(user) {
  return !user || !user.account
    ? 'NotInvited'
    : user.account.active
    ? 'Active'
    : 'Inactive'
}
